import React from "react";
import { useTranslation } from "react-i18next";

const OurMission = () => {
  const { t } = useTranslation();
  return (
    <section className="py-20 px-4 bg-grey-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-neutral-green-500 text-4xl md:text-6xl font-bold mb-12 text-center">
          {t("about.ourMission")}
        </h2>
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-lg text-neutral-green-700 mb-6">
            {t("about.missionP1")}
          </p>
          <p className="text-lg text-neutral-green-700 mb-6">
            {t("about.missionP2")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurMission;
